import { Calculator, ArrowSquareOut } from "@phosphor-icons/react";

export const PAYROLL_URL = "https://payrolltaxcalc.com";

export function PayrollCalcCard({ testid = "payroll-calc-card" }) {
  return (
    <a href={PAYROLL_URL} target="_blank" rel="noopener" className="glass p-5 mb-6 flex flex-wrap items-center gap-4 group transition-transform duration-200 hover:-translate-y-0.5" data-testid={testid}>
      <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-600 text-white flex items-center justify-center shrink-0"><Calculator size={22} /></div>
      <div className="flex-1 min-w-[220px]">
        <p className="font-display font-semibold">Need your exact take-home pay? Try PayrollTaxCalc.com</p>
        <p className="text-sm text-muted-foreground">The most accurate payroll calculator, to the penny. Covers all 50 states, retirement contributions, benefit withholding and "what if" scenarios to help you decide on future changes.</p>
      </div>
      <span className="text-sm font-medium text-cyan-700 dark:text-cyan-400 flex items-center gap-1">Open calculator <ArrowSquareOut size={16} className="transition-transform duration-200 group-hover:translate-x-0.5" /></span>
    </a>
  );
}
